import React from "react";
import {
  IonIcon,
  IonPage,
  IonHeader,
  IonToolbar,
  IonButtons,
  IonButton,
  IonTitle,
  IonContent,
  IonProgressBar, withIonLifeCycle,
} from "@ionic/react";
import {document, clipboard, arrowBack, calendar} from "ionicons/icons";
import AbaEvento from "./AbaEvento";
import AbaQuestionario from "./AbaQuestionario";
import {EventoObject} from "../../models/Evento";
import fb from "../../lib/firebase";
import {goBackNG} from "../../lib/utils";
import {NavFooter} from "../../components/NavFooter";
import moment from "moment";
import {AppState} from "../../models/app";
import {AppDispatch, RootState} from "../../global.state";
import {connect} from "react-redux";
import {debug} from "../../config";


interface Props {
  history: any;
  match: any;
  app: AppState;
  dispatch: AppDispatch;
}

interface State {
  selectedTab: string;
  instance: EventoObject | undefined;
  loading: boolean;
}

class Evento extends React.Component<Props, State> {
  private cancelListener: () => void;

  constructor(props: Props) {
    super(props);

    this.state = {
      selectedTab: "home",
      instance: undefined,
      loading: true,
    };

    this.cancelListener = () => {};
  }

  ionViewWillEnter() {
    // reset state
    const instanceId = this.props.match.params.instanceId;
    const instance = this.state.instance;
    if ( !instance || instance.id !== instanceId) {
      this.setState({instance: undefined, loading: true, selectedTab: "home"});
    }

    this.installListener();
  }
  ionViewDidLeave() {
    this.cancelListener();
  }

  installListener = () => {
    const doc = fb.db.collection('eventos').doc(this.props.match.params.instanceId);
    this.cancelListener = doc.onSnapshot((snap) => {
      const instance = fb.doc(snap) as EventoObject;
      debug(`Evento (${snap.ref.path})`, instance);
      this.setState({
        instance,
        loading: false,
      });
    });
  };

  onChangeTab = (selectedTab:string) => {
    this.setState({selectedTab});
  };

  onClickBack = () => {
    goBackNG(this.props.app.jumpHistory, this.props.dispatch, this.props);
  };

  render() {
    const tabs:any[] = [
      {
        tab: "home",
        icon: document,
        label: "Evento",
      },
      {
        tab: "questionario",
        icon: clipboard,
        label: "Questionário",
      },
    ];

    const {instance} = this.state;

    return (
      <IonPage>
        <IonHeader>
          <IonToolbar color="primary">
            <IonButtons slot="start">
              <IonButton onClick={this.onClickBack}>
                <IonIcon slot="start" icon={arrowBack}/>
              </IonButton>
            </IonButtons>
            <IonTitle className="font-condensed">
              {
                instance &&
                  <>
                    {instance.tipo} em {moment(instance.data.toDate()).format('DD/MM/YYYY')}
                  </>
              }
            </IonTitle>
            <IonIcon icon={calendar} slot="primary" class="pr-3 text-2xl"/>
          </IonToolbar>
        </IonHeader>

        <IonContent>
          {
            !this.state.instance ? <IonProgressBar type="indeterminate"/> :
              <>
                {
                  this.state.selectedTab === "home" &&
                  <AbaEvento
                    instance={this.state.instance}
                    goBack={this.onClickBack}
                    loading={this.state.loading}
                  />
                }
                {
                  this.state.selectedTab === "questionario" &&
                  <AbaQuestionario
                    instance={this.state.instance}
                    history={this.props.history}
                  />
                }
              </>
          }
        </IonContent>
        <NavFooter
          value={this.state.selectedTab}
          onChange={this.onChangeTab}
          tabs={tabs}
        />
      </IonPage>
    );
  }
}

export default connect(({app}: RootState) => ({app}))(withIonLifeCycle(Evento));